import React from 'react';
import { IcomoonIcon } from '@acf/icon-picker/acf-icon-picker';
export default function Icon({ iconClassName, iconName, iconPack, iconPackType, iconPrefix }) {
    if (iconPackType == 'icomoon') {
        return React.createElement(IcomoonIcon, { name: iconName });
    }
    else {
        return React.createElement("i", { className: `${iconPrefix} ${iconClassName}` });
    }
}
